import { addAST, multiplyAST, subtractAST } from '../lscriptUtils';
import { defBaseUnit, defCustomUnit } from '../registry';

export const temperatureUnits = [
  defBaseUnit('celsius'),
  defCustomUnit('kelvin', { kelvin: 1 }, 'celsius', {
    toBase: (v) => subtractAST(v, 273.15),
    fromBase: (v) => addAST(v, 273.15),
  }),
  defCustomUnit('fahrenheit', { fahrenheit: 1 }, 'celsius', {
    toBase: (v) => multiplyAST(subtractAST(v, 32), 5 / 9),
    fromBase: (v) => addAST(multiplyAST(v, 9 / 5), 32),
  }),
];
